import React from 'react';
import { useEffect, useState, useRef } from "react";
import NavButton from '../homepage/header-banner/TopNavButton';
import Footer from '../homepage/footer/Footer';
import { Link, useLocation } from "react-router-dom";
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
import { ChevronRight } from "@mui/icons-material";
import Image1 from './image/img1.png'
import Image2 from './image/img2.png'
import Image3 from './image/img3.png'
import Image4 from './image/img4.png'
import Image5 from './image/img5.png'
import Image6 from './image/img6.png'
import Image7 from './image/img7.png'
import BgBan from './image/bg-ban.png'
import Elementglobal from './image/Element.png';
import Elementglobal2 from './image/Element-2.png';
import Elementglobal3 from './image/Element-3.png';
import Elementglobal4 from './image/Element-4.png';
import Elementglobal5 from './image/Element-5.png';
import Elementglobal6 from './image/Element-6.png';
import Elementglobal7 from './image/Element-7.png';
import FadeInSection from '../container/component/Fadeanimation/FadeInSection';
import LazyMap from '../container/component/map/lazymap';
import './global-style.css'
import '../Style/typo.css'

const ScrollToSection = () => {
    const location = useLocation();

    useEffect(() => {
        if (location.hash) {
            const section = document.querySelector(location.hash);
            if (section) {
                section.scrollIntoView({ behavior: "smooth" });
            }
        }
    }, [location]);

    return null;
};

function GlobalPage2() {

    return (
        <div className='global-page2'>
            <NavButton option={{
                // logo: logoKube,
                logo: "https://hanbiro.com/cloud/library/banner/hanbiro.svg",
                link: "https://hanbiro.com/",
                color: { backgroundColor: '#7061ff' },
                itemNavClass: "item-nav nav-pur",
                menuListProduct: "menu-list-product-item",
                menuListVora: "vora",
                menuListGroupware: "groupware",
                titleTab: "mb-3",
            }} />
            <ScrollToSection />
            <div className="header-ban-global">
                <div className="fit-box p-r-l">
                    <FadeInSection>
                        <div className="header-ban-tt">
                            <div className="header-ban-tt-left">
                                <img src="https://hanbiro.com/assets/images/cloud/hanbiro-global/map-6.png" />
                            </div>
                            <div className="header-ban-tt-right">
                                <Link to="#ai-call" className="ban-tt-list">
                                    <div className="ban-tt-icon">
                                        <ChevronRight className="vector-icon wh-color" />
                                    </div>
                                    <div className="ban-tt-text wh-color">AI 통합 그룹웨어솔루션</div>
                                </Link>
                                <Link to="#microservice" className="ban-tt-list">
                                    <div className="ban-tt-icon">
                                        <ChevronRight className="vector-icon wh-color" />
                                    </div>
                                    <div className="ban-tt-text wh-color">기업전용 클라우드 서버 관리•운영</div>
                                </Link>
                                <Link to="#kubernetes" className="ban-tt-list">
                                    <div className="ban-tt-icon">
                                        <ChevronRight className="vector-icon wh-color" />
                                    </div>
                                    <div className="ban-tt-text wh-color">기업전용 쿠버네티스 클러스터 인프라 구축•관리</div>
                                </Link>
                                <Link to="#ai-groupware" className="ban-tt-list">
                                    <div className="ban-tt-icon">
                                        <ChevronRight className="vector-icon wh-color" />
                                    </div>
                                    <div className="ban-tt-text wh-color">기업전용 AI (LLM) 개발•관리운영</div>
                                </Link>
                                <Link to="#microservice" className="ban-tt-list">
                                    <div className="ban-tt-icon">
                                        <ChevronRight className="vector-icon wh-color" />
                                    </div>
                                    <div className="ban-tt-text wh-color">클라우드기반 마이크로서비스 API 제공</div>
                                </Link>
                            </div>
                        </div>
                    </FadeInSection>
                </div>
            </div>

            <div className='wrap-box global-fea1'>
                <div className='fit-box'>
                    <FadeInSection>
                        <div className="wrap-title">
                            <p className="typo-32">주요서비스</p>
                        </div>
                    </FadeInSection>


                    <FadeInSection>
                        <div className='wrap-content-fea1'>
                            <div className='wrap-ct-box' id="ai-call">
                                <div className='wrap-item'>
                                    {/* <div className='fea-tooltip txt-14'><span>&nbsp;</span>AI call 화면캡쳐 (음성추출/대화화면)</div> */}
                                    <p className='fea-title typo-21 typo-medium'>AI 통합 그룹웨어솔루션</p>
                                    <div className='fea-content-gr'>
                                        <div className='fea-content'>
                                            <p className='typo-14'>영어•중국어•베트남어•일본어 음성추출 / 요약 및 번역</p>
                                            <p className='typo-14'>다국적 임직원의 음성통화 관리</p>
                                            <p className='typo-14'>실시간 다국어 메세징 교환</p>

                                        </div>
                                        <div className='fea-btn'>
                                            <button><a class="url-btn" href="https://www.hanbiro.com/software/groupware-free-trial.html?SM=SPCMAKO">서비스신청</a></button>
                                        </div>
                                    </div>
                                </div>
                                <div className='wrap-item'>
                                    <div className='wrap-item-img'>
                                        <img src="https://hanbiro.com/assets/images/cloud/hanbiro-global/crm-rectangle-2.png" />
                                    </div>
                                </div>
                            </div>

                            <div className='wrap-ct-box' id="server">
                                <div className='wrap-item'>
                                    {/* <div className='fea-tooltip txt-14'><span>&nbsp;</span>BareMetal 서버이미지</div> */}
                                    <p className='fea-title typo-21 typo-medium'>기업전용 클라우드 서버 관리 • 운영</p>
                                    <div className='fea-content-gr'>
                                        <div className='fea-content'>
                                            <p className='typo-14'>전용 서비스 모니터프로그램 24시간운영</p>
                                            <p className='typo-14'>전문 서버엔지니어의 관리 · 운영지원</p>
                                            <p className='typo-14'>8,000 관계사, 5,000 대의 서버운영 노하우보유</p>
                                        </div>
                                        <div className='fea-btn'>
                                            <button><a class="url-btn" href="https://www.hanbiro.com/application/index.html?Manage=mt1">서비스신청</a></button>
                                        </div>
                                    </div>

                                </div>
                                <div className='wrap-item'>
                                    <div className='wrap-item-img'>
                                        <img src="https://hanbiro.com/assets/images/cloud/hanbiro-global/server-rectangle-2.png" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </FadeInSection>

                    <FadeInSection>
                        <div className='wrap-content-fea1' data-aos="fade-up" data-aos-duration="1500">
                            <div className='wrap-ct-box' id="kubernetes">
                                <div className='wrap-item'>
                                    {/* <div className='fea-tooltip txt-14'><span>&nbsp;</span>Kubernetes 페이지 이미지</div> */}
                                    <p className='fea-title typo-21 typo-medium'>기업전용 쿠버네티스 클러스터 인프라 구축 • 관리</p>
                                    <div className='fea-content-gr'>
                                        <div className='fea-content'>
                                            <p className='typo-14'>서버자원의 효율적인 운영, 리소스의 자동 축소 · 확장</p>
                                            <p className='typo-14'>자동재해복구 · 오토스케일링기능, 서비스의 영속성보장</p>
                                            <p className='typo-14'>고객사 전용 프라이빗 클러스터 인프라구축, 보안강화</p>
                                        </div>
                                        <div className='fea-btn'>
                                            <button><a class="url-btn" href="https://www.hanbiro.com/application/index.html?Manage=mt1">서비스신청</a></button>
                                        </div>
                                    </div>

                                </div>
                                <div className='wrap-item'>
                                    <div className='wrap-item-img'>
                                        <img src="https://hanbiro.com/assets/images/cloud/hanbiro-global/kube-rectangle-2.png" />
                                    </div>
                                </div>
                            </div>

                            <div className='wrap-ct-box' id="ai-groupware">
                                <div className='wrap-item'>
                                    {/* <div className='fea-tooltip txt-14'><span>&nbsp;</span>메일 번역/요약화면</div> */}
                                    <p className='fea-title typo-21 typo-medium'>기업전용 AI (LLM) 인프라 개발 • 관리운영</p>
                                    <div className='fea-content-gr'>
                                        <div className='fea-content'>
                                            <p className='typo-14'>기업전용 LLM 서버구축, 기업의 독립적인 AI 인프라구축</p>
                                            <p className='typo-14'>기업내의 데이터유출 방지•고객데이터 보호</p>
                                            <p className='typo-14'>최적의 LLM 모델 적용 및 개발•관리</p>
                                        </div>
                                        <div className='fea-btn'>
                                            <button><a class="url-btn" href="https://www.hanbiro.com/software/groupware-free-trial.html?SM=SPCMAKO">서비스신청</a></button>
                                        </div>
                                    </div>

                                </div>
                                <div className='wrap-item'>
                                    <div className='wrap-item-img'>
                                        <img src="https://hanbiro.com/assets/images/cloud/hanbiro-global/llm-server-rectangle-2.png" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </FadeInSection>


                    <FadeInSection>
                        <div className='wrap-ct-box fea-bottom' id="microservice">
                            <div className='wrap-item'>
                                {/* <div className='fea-tooltip txt-14'><span>&nbsp;</span>Event Sourcing 상단이미지사용</div> */}
                                <p className='fea-title typo-21 typo-medium'>클라우드기반 마이크로서비스 API 제공</p>
                                <div className='fea-content-gr'>
                                    <div className='fea-content'>
                                        <p className='typo-14'>이벤트 소싱 기반 분산 아키텍처 및 서버리스 시스템 구축</p>
                                        <p className='typo-14'>IAM, OAuth, Role 기반 권한 관리로 안전한 Access Control 제공</p>
                                        <p className='typo-14'>메시징, Webhook, Scheduler 등 이벤트 기반 자동화 기능 지원</p>
                                    </div>
                                    {/* <div className='fea-btn'>
                                        <button><a class="url-btn" href="https://www.hanbiro.com/application/index.html?Manage=mt1">서비스신청</a></button>
                                    </div> */}
                                </div>

                            </div>
                            <div className='wrap-item'>
                                <div className='wrap-item-img'>
                                    <img src="https://hanbiro.com/assets/images/cloud/hanbiro-global/microservice-rectangle-2.png" />
                                </div>
                            </div>
                        </div>
                    </FadeInSection>



                </div>
            </div>

            <div className='wrap-box'>
                <div className='fit-box'>
                    <FadeInSection>
                        <div className='boximage-global'>
                            <div className="wrap-title titlebox-global">
                                <p className="typo-32">한비로 베트남 법인 • 연구소</p>
                            </div>
                            <div className="boximage1-global">
                                <div className="listimage-global">
                                    <div className="image1-global">
                                        <img src="https://hanbiro.com/cloud/library/outsourcing/Company 7.png" />
                                    </div>
                                    <div className="image1-global">
                                        <img src="https://hanbiro.com/cloud/library/outsourcing/Company 6.svg" />
                                    </div>
                                    <div className="image1-global">
                                        <img src="https://hanbiro.com/cloud/library/outsourcing/Company 2.svg" />
                                    </div>
                                </div>

                                <div className="listimage2-global">
                                    <div className="image1-global">
                                        <img src="https://hanbiro.com/cloud/library/outsourcing/Company 8.png" />
                                    </div>
                                    <div className="image1-global">
                                        <img src="https://hanbiro.com/cloud/library/outsourcing/Company 3.svg" />
                                    </div>
                                    <div className="image1-global">
                                        <img src="https://hanbiro.com/cloud/library/outsourcing/Company 4.svg" />
                                    </div>
                                </div>
                            </div>

                            <div className='boxcard-global-gr'>
                                <div className="boxcard-global">
                                    <div className="card-content-global" data-aos="flip-up" data-aos-duration="1000" data-aos-offset="20">
                                        <div className="card-title-global">
                                            <p className="typo-21-sm typo-medium">
                                                MICROSERVICE 개발팀
                                            </p>
                                            <p className="typo-14 typo-gray">
                                                12 Members
                                            </p>
                                        </div>

                                    </div>

                                    <div className="card-content-global" data-aos="flip-up" data-aos-duration="1000" data-aos-offset="20">
                                        <div className="card-title-global">
                                            <p className="typo-21-sm typo-medium">
                                                MOBILE 개발팀
                                            </p>
                                            <p className="typo-14 typo-gray">
                                                7 Members
                                            </p>
                                        </div>

                                    </div>

                                    <div className="card-content-global" data-aos="flip-up" data-aos-duration="1000" data-aos-offset="20">
                                        <div className="card-title-global">
                                            <p className="typo-21-sm typo-medium">
                                                기업소프트웨어 개발팀
                                            </p>
                                            <p className="typo-14 typo-gray">
                                                17 Members
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div className="boxcard-global box2-global">
                                    <div className="card-content-global" data-aos="flip-up" data-aos-duration="1000" data-aos-offset="20">
                                        <div className="card-title-global">
                                            <p className="typo-21-sm typo-medium">
                                                그룹웨어 개발팀
                                            </p>
                                            <p className="typo-14 typo-gray">
                                                12 Members
                                            </p>
                                        </div>

                                    </div>

                                    <div className="card-content-global" data-aos="flip-up" data-aos-duration="1000" data-aos-offset="20">
                                        <div className="card-title-global">
                                            <p className="typo-21-sm typo-medium">
                                                클라우드서비스 운영팀
                                            </p>
                                            <p className="typo-14 typo-gray">
                                                15 Members
                                            </p>
                                        </div>

                                    </div>

                                    <div className="card-content-global" data-aos="flip-up" data-aos-duration="1000" data-aos-offset="20">
                                        <div className="card-title-global">
                                            <p className="typo-21-sm typo-medium">
                                                PL / QC 관리팀
                                            </p>
                                            <p className="typo-14 typo-gray">
                                                6 Members
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </FadeInSection>
                </div>
            </div>

            <div className='wrap-box global-fea4'>
                <div className='fit-box'>
                    <div className="wrap-title">
                        <p className="typo-32">글로벌 한비로</p>
                    </div>

                    <div className='wrap-content'>
                        <ul class="nav nav-pills" id="pills-tab" role="tablist">
                            <li class="nav-item" role="presentation">
                                <button class="nav-link typo-21 typo-medium active" id="pills-address1-tab" data-bs-toggle="pill" data-bs-target="#pills-address1" type="button" role="tab" aria-controls="pills-address1" aria-selected="true">한국</button>
                            </li>
                            <li class="nav-item" role="presentation">
                                <button class="nav-link typo-21 typo-medium" id="pills-address2-tab" data-bs-toggle="pill" data-bs-target="#pills-address2" type="button" role="tab" aria-controls="pills-address2" aria-selected="false">베트남</button>
                            </li>
                            <li class="nav-item" role="presentation">
                                <button class="nav-link typo-21 typo-medium" id="pills-address3-tab" data-bs-toggle="pill" data-bs-target="#pills-address3" type="button" role="tab" aria-controls="pills-address3" aria-selected="false">미국</button>
                            </li>
                            <li class="nav-item" role="presentation">
                                <button class="nav-link typo-21 typo-medium" id="pills-address4-tab" data-bs-toggle="pill" data-bs-target="#pills-address4" type="button" role="tab" aria-controls="pills-address4" aria-selected="false">중국</button>
                            </li>
                            {/* <li class="nav-item" role="presentation">
                                <button class="nav-link typo-21 typo-medium" id="pills-address5-tab" data-bs-toggle="pill" data-bs-target="#pills-address5" type="button" role="tab" aria-controls="pills-address5" aria-selected="false">일본</button>
                            </li> */}
                        </ul>
                        <div class="tab-content" id="pills-tabContent">
                            <div class="tab-pane show active" id="pills-address1" role="tabpanel" aria-labelledby="pills-address1-tab">
                                <div className='wrap-ct-box-address'>
                                    <div className='wrap-item-address'>
                                        <div className='map-box'>
                                            <LazyMap src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d8723.123543440124!2d127.02004400000001!3d37.48317900000001!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357ca13e403a11a1%3A0x9c70026c0f395dc6!2z7ISc7Jq47Yq567OE7IucIOyEnOy0iOq1rCDrgqjrtoDsiJztmZjroZwzMzPquLggOQ!5e1!3m2!1sko!2skr!4v1744184156250!5m2!1sko!2skr"
                                            />
                                        </div>
                                        <div className='map-text-box'>
                                            <p className='typo-21-sm typo-medium mb-2'>사무실</p>
                                            <p className='typo-14'>서울시 서초구 남부순환로333길 9 4,5층(효천빌딩) (주)한비로</p>
                                            {/* <div className='txt-14'>대표 전화 : 1544-4755</div> */}
                                        </div>
                                    </div>
                                    <div className='wrap-item-address'>
                                        <div className='map-box'>
                                            <LazyMap src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d8723.109766637504!2d127.02214000000001!3d37.483297!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357ca13ee3ab0e51%3A0xbddf9d0fc3e06c55!2s2481%20Nambusunhwan-ro%2C%20Seocho%20District%2C%20Seoul%2C%20South%20Korea!5e1!3m2!1sen!2sus!4v1744188248128!5m2!1sen!2sus"
                                            />
                                        </div>
                                        <div className='map-text-box'>
                                            <p className='typo-21-sm typo-medium mb-2'>IDC : LG U+ 서초센터</p>
                                            {/* <div className='txt-14'>운영 장비 현황 : 3600여 대</div> */}
                                            <p className='typo-14'>위치 : 서울특별시 서초구 남부순환로 2481 KIDC 서초1센터</p>
                                        </div>
                                    </div>
                                </div>

                                <div className='wrap-ct-box-address'>
                                    <div className='wrap-item-address'>
                                        <div className='map-box'>
                                            <LazyMap src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d34892.97799003453!2d126.879855!3d37.482143!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357c9e1d58ec5037%3A0x9024f7fea8edc505!2s189%20Gasan%20digital%201-ro%2C%20Geumcheon%20District%2C%20Seoul%2C%20South%20Korea!5e1!3m2!1sen!2sus!4v1744188536265!5m2!1sen!2sus"
                                            />
                                        </div>
                                        <div className='map-text-box'>
                                            <p className='typo-21-sm typo-medium mb-2'>IDC : LG U+ 가산 센터</p>
                                            {/* <div className='txt-14'>운영 장비 현황 : 640여 대</div> */}
                                            <p className='typo-14'>위치 : 서울특별시 금천구 가산디지털1로 189</p>
                                        </div>
                                    </div>
                                    <div className='wrap-item-address'>
                                        <div className='map-box'>
                                            <LazyMap src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d17441.572189998!2d127.04639700000001!3d37.503195000000005!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357ca3fdf0a0991b%3A0xa94c807c25837b66!2z7ZiE64yA7ZW07IOBIOqwleuCqOqzoOqwneyngOybkO2MgA!5e1!3m2!1sen!2sus!4v1744188634974!5m2!1sen!2sus"
                                            />
                                        </div>
                                        <div className='map-text-box'>
                                            <p className='typo-21-sm typo-medium mb-2'>IDC : 세종 센터</p>
                                            {/* <div className='txt-14'>운영 장비 현황 : 130여 대</div> */}
                                            <p className='typo-14'>위치 : 서울특별시 강남구 테헤란로 137 현대 해상 빌딩 6층</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane" id="pills-address2" role="tabpanel" aria-labelledby="pills-address2-tab">
                                <div className='wrap-ct-box-address'>
                                    <div className='wrap-item-address'>
                                        <div className='map-box'>
                                            <LazyMap src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5399.654115858495!2d106.7471928!3d10.7654564!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3175250006201481%3A0xec754ba5ba9f512!2sC%C3%B4ng%20ty%20TNHH%20Hanbiro%20Vi%E1%BB%87t%20Nam!5e1!3m2!1svi!2s!4v1744343219111!5m2!1svi!2s"
                                            />
                                        </div>
                                        <div className='map-text-box'>
                                            <p className='typo-21-sm typo-medium mb-2'>사무실</p>
                                            <p className='typo-14 address-2'>Phòng 106, KOTITI, đường 19C, Tân Thuận Đông, Quận 7, Hồ Chí Minh</p>
                                            <p className='typo-14'>대표 전화 : 1800 6346</p>
                                        </div>
                                    </div>
                                    <div className='wrap-item-address'>
                                        <div className='map-box'>
                                            <LazyMap src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5399.620390153095!2d106.7443389118303!3d10.767338389336622!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31752599f3304c4d%3A0x1bb1f9d9fb8aee11!2zRlBUIFTDom4gVGh14bqtbiAz!5e1!3m2!1svi!2sus!4v1744342307522!5m2!1svi!2sus" />

                                        </div>
                                        <div className='map-text-box'>
                                            <p className='typo-21-sm typo-medium mb-2'>IDC : FPT Telecom</p>
                                            <p className='typo-14 address-2'>Lô B3 Đ. Sáng Tạo, Tân Thuận Đông, Quận 7, Hồ Chí Minh 756200, Việt Nam</p>
                                            <p className='typo-14'>대표 전화 : +84 873 002222</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane" id="pills-address3" role="tabpanel" aria-labelledby="pills-address3-tab">
                                <div className='wrap-ct-box-address'>
                                    <div className='wrap-item-address'>
                                        <div className='map-box'>
                                            <LazyMap src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4553.530167040678!2d-118.29423538768364!3d34.05930827304247!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c2c77913c33649%3A0x9d865a309dbe3937!2s711%20S%20Vermont%20Ave%20%23209%2C%20Los%20Angeles%2C%20CA%2090005!5e1!3m2!1svi!2sus!4v1744189176439!5m2!1svi!2sus"
                                            />
                                        </div>
                                        <div className='map-text-box'>
                                            <p className='typo-21-sm typo-medium mb-2'>사무실</p>
                                            <p className='typo-14'>711 S. VERMONT AVE.STE 209 LOS ANGELES, CA 90005</p>
                                        </div>
                                    </div>
                                    <div className='wrap-item-address'>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane" id="pills-address4" role="tabpanel" aria-labelledby="pills-address4-tab">
                                <div className='wrap-ct-box-address'>
                                    <div className='wrap-item-address'>
                                        <div className='map-box'>
                                            <LazyMap src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d10154.628540134972!2d113.933433!3d22.518741!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3403ee3eec548cdd%3A0x9eb641c8a8273981!2sTianli%20Center%20Business%20Plaza%20Garage!5e1!3m2!1sen!2sus!4v1744189356184!5m2!1sen!2sus"
                                            />
                                        </div>
                                        <div className='map-text-box'>
                                            <p className='typo-21-sm typo-medium mb-2'>사무실</p>
                                            <p className='typo-14'>深圳市南山区后海大道东路天利中央商务广场A座11楼1108G</p>
                                            {/* <div className='txt-14'>대표 전화 : 185-7550-4792</div> */}
                                        </div>
                                    </div>
                                    <div className='wrap-item-address'>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane" id="pills-address5" role="tabpanel" aria-labelledby="pills-address5-tab">
                                <div className='wrap-ct-box-address'>
                                    <div className='wrap-item-address'>
                                        <div className='map-box'>
                                            <LazyMap src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d8930.281283125634!2d139.747241!3d35.671183!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188b6ee6336ccf%3A0xb12f33a943781b2a!2sKasumigaseki%20Building!5e1!3m2!1sen!2sus!4v1744189513768!5m2!1sen!2sus"
                                            />
                                        </div>
                                        <div className='map-text-box'>
                                            <p className='typo-21-sm typo-medium mb-2'>사무실</p>
                                            <p className='typo-14'>〒100-6005 東京都千代田区霞が関3-2-5 霞が関ビルディング 5階 KOTRA</p>
                                            {/* <div className='txt-14'>대표 전화 : 03-6869-1001</div> */}
                                        </div>
                                    </div>
                                    <div className='wrap-item-address'>
                                        <div className='map-box'>
                                            <LazyMap src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d17861.8410416838!2d139.836859!3d35.665469!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188869a78afd0b%3A0x7e4095ab70950712!2s3-ch%C5%8Dme-4-4%20Shinsuna%2C%20Koto%20City%2C%20Tokyo%20136-0075%2C%20Japan!5e1!3m2!1sen!2sus!4v1744189552189!5m2!1sen!2sus"
                                            />
                                        </div>
                                        <div className='map-text-box'>
                                            <p className='typo-21-sm typo-medium mb-2'>IDC : Softbank Telecom</p>
                                            {/* <div className='txt-14'>운영 장비 현황 : 320여 대</div> */}
                                            <p className='typo-14'>위치 : ソフトバンクテレコム 東京第四データセンター(日本東京都江東区新砂３丁目４−４)</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer option={{
                textColor: "text-color external-link text-pur-color",
                textlinkColor: "text-color text-pur-color",
            }} />
        </div>
    )
}

export default GlobalPage2;
